export default __webpack_public_path__ + "static/okr-framework-b733a9ee9686324569981618b7ba0482.webm";